
import TableList from "@components/templates/tablelist";
import { HttpSummaryAccountList } from '@/service/boss/allot';
import { mapState,mapGetters } from "vuex";
export default {
    mixins: [TableList],
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                }
            },
            Searchs: {
                show: true,
                labelWidth: 120,
            },
            Plugins: {show: true},
            erpSkusList:[],
            category:'',
        }
    },
    methods: {
        ajaxRequest: HttpSummaryAccountList,
    },
    computed: {
        ...mapGetters('diction',['getNewDifferentAllProductList','getNewAccountList']),
        // 搜索下拉框展示内容
        SearchsData() {
            return  [
                {
                    label: this.$t('global.common.project',{defaultValue:'项目'}),
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    options: this.getNewDifferentAllProductList,
                    props:{
                        filterable:true,
                    },
                    show:true,
                },

                {
                    label: this.$t('global.common.channel',{defaultValue:'店铺'}),
                    tag: 'vSelect',
                    key: 'EQ_accountFlag',
                    show:true,
                    options: this.getNewAccountList,
                    props:{
                        filterable:true,
                    }
                },

                {
                    label: "SellerSKU",
                    tag: 'vInput',
                    key: 'EQ_sellerSku',
                    show:true,
                },
                {
                    label: "ERPSKU",
                    tag: 'vInput',
                    key: 'EQ_erpSku',
                    show:true,
                },
            ]
        },
        // table的展示数据
        columns() {
            return  [
            {
                title: this.$t('global.common.project',{defaultValue:'项目'}),
                render: (h, { row }) => this.findRenderLabel(this.getNewDifferentAllProductList, row.lineId)
            },
            {
                title: this.$t('erp.managewarehouse.shop_type',{defaultValue:'店铺类型'}),
                key:'accountType',
            },
            {
                title: this.$t('global.common.channel',{defaultValue:'店铺'}),
                key:'accountFlag',
            },
            {
                title: 'SellerSKU',
                key:'sellerSku',
                sortable: true
            },
            {
                title: 'ERPSKU',
                key:'erpSku',
                sortable: true
            },
            {
                title: this.$t('erp.virtualstore.computationnumber',{defaultValue:'计算数量'}),
                key: 'total',
                sortable: true
            },
            
            {
                title: this.$t('global.common.updatedAt',{defaultValue:'更新时间'}),
                key: 'updatedAt',
                sortable: true
            },
            {
                title: this.$t('erp.channel.is_push',{defaultValue:'是否推送'}),
                sortable: true,
                render: (h,{ row }) => {
                    const aa = row.isPush == true ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'})
                    return <span>{aa}</span>
                }
            },
        ];
        },
        
    },

};
